import { WorldRenderer } from "../WorldRenderer";

export abstract class BaseService {
  constructor(protected worldRenderer: WorldRenderer) {
  }
  // Initialization code if needed
  public load(): Promise<void> {
    return Promise.resolve();
  }
  abstract render(delta: number): void;
  public dispose(): void { }
  public getService<T extends BaseService>(type: new (wr: WorldRenderer) => T): T {
    const part = this.worldRenderer.services.find((f) => f instanceof type) as T;
    if (!part) {
      throw new Error(`Part not found: ${type.name}`);
    }
    return part;
  }
}